import multiSelectComponent from './multi-select.component';

const multiSelectModule = angular.module('multiSelect', [
])
  .component('multiSelect', multiSelectComponent)
  .name;

export default multiSelectModule;
